import { connect } from 'react-redux';
import AppRoute from './AppRoute';
import * as actions from '../../actions';

const AppRouteContainer = (props) => <AppRoute {...props} />;

const mapStateToProps = (state) => ({
  userAuth: state.login.userAuth,
  isOnline: state.parameter.isOnline,
});

const mapDispatchToProps = (dispatch) => ({
  setWindowInnerWidth(width) {
    dispatch(actions.setWindowInnerWidth(width));
  },
  setIsOnline(isOnline) {
    dispatch(actions.setIsOnline(isOnline));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouteContainer);
